import { useMemo } from 'react'
import { useFirestoreQuery } from '../../../../../firebase/useFirestore'
import usePersonaReadFailure from './usePersonaReadFailure'
import { ladderStepsFromParticipation } from '../../../../../helpers/participationHelpers/ladderSteps'

// De participatieladder van de deelnemer van het rapport, in de app. Een eigen
// hook zodat de widget op de openbare link dezelfde weergave kan voeden met
// `personaData.ladder` van de server (publicLadderState), in dezelfde vorm.
// De treden staan op het persona-document zelf (`Participation.t0/t1`).
// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure

/** @typedef {'idle' | 'loading' | 'error' | 'missing' | 'ready'} PersonaLadderStatus */

/**
 * @param {string|null} personaId - Uit useWidgetPersona; `null` = niets lezen
 * @returns {{ status: PersonaLadderStatus, steps: import('../../../../../helpers/participationHelpers/ladderSteps').LadderSteps|null }}
 */
const usePersonaLadder = (personaId) => {
    const { failed, onError } = usePersonaReadFailure(personaId)

    const personas = useFirestoreQuery('Personas', {
        where: [['ID', '==', personaId || '']],
        enabled: !!personaId,
        onError,
    })

    return useMemo(() => {
        if (!personaId) return { status: 'idle', steps: null }
        if (failed) return { status: 'error', steps: null }
        // '' = nog niet geladen (de begintoestand van useFirestoreQuery).
        if (!Array.isArray(personas)) return { status: 'loading', steps: null }
        if (!personas[0]) return { status: 'missing', steps: null }
        return { status: 'ready', steps: ladderStepsFromParticipation(personas[0].Participation) }
    }, [personaId, failed, personas])
}

export default usePersonaLadder
